<template>
  <div class="bit-assist">
    <transition name="popup-slide">
      <div v-show="isOpen" class="bit-assist-popup">
        <a
          v-for="channel in channels"
          :key="channel.key"
          :href="channel.url"
          target="_blank"
          class="bit-assist-channel"
        >
          <img
            :src="channel.icon"
            :alt="$t('weightLoss.bitAssist.' + channel.key)"
            class="channel-icon"
          />
          <span class="channel-label">{{ $t('weightLoss.bitAssist.' + channel.key) }}</span>
        </a>
      </div>
    </transition>

    <button class="bit-assist-btn" @click="isOpen = !isOpen">
      <i class="bi bi-chat-dots-fill"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "BitAssistWidget",
  data() {
    return {
      isOpen: false,
      channels: [
        { key: "call", url: "tel:7547521888", icon: "/images/weight-loss/call-sms-icon.jpg" },
        { key: "sms", url: "sms:7547521888", icon: "/images/weight-loss/call-sms-icon.jpg" },
        {
          key: "whatsapp",
          url: "https://api.whatsapp.com/send/?phone=7542761746&text=How Can I Help You?",
          icon: "/images/weight-loss/whatsapp-icon.svg",
        },
      ],
    };
  },
};
</script>

<style scoped>
.bit-assist {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9998;
}

.bit-assist-btn {
  width: 60px;
  height: 60px;
  background: #00ffa3;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease;
}

.bit-assist-btn:hover {
  transform: scale(1.05);
}

.bit-assist-btn i {
  color: #fff;
  font-size: 28px;
}

.bit-assist-popup {
  position: absolute;
  bottom: 70px;
  right: 0;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  min-width: 180px;
}

.bit-assist-channel {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  text-decoration: none;
  color: #333;
  transition: background 0.15s ease;
}

.bit-assist-channel:hover {
  background: #f5f5f5;
}

.channel-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.channel-label {
  font-size: 15px;
  font-weight: 500;
}

/* Transition */
.popup-slide-enter-active,
.popup-slide-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.popup-slide-enter-from,
.popup-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
